import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
  const { loginWithSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) return navigate("/login", { replace: true });
      try {
        const u = await loginWithSession(sessionId, "titiper");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.role === "admin" ? "/admin" : "/home", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithSession, navigate]);

  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center gap-4">
      <Logo light size={44} />
      <p className="text-white/70 text-sm">Menyiapkan akun kamu...</p>
    </div>
  );
}
